__turbopack_context__.v({
  "container": "styles-module__-ls_zG__container",
  "icon": "styles-module__-ls_zG__icon",
});
